import { render } from "./BarcodeItems.vue?vue&type=template&id=e4ed6178&scoped=true"
import script from "./BarcodeItems.vue?vue&type=script&lang=js"
export * from "./BarcodeItems.vue?vue&type=script&lang=js"

import "./BarcodeItems.vue?vue&type=style&index=0&id=e4ed6178&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ed6178"]])

export default __exports__